export default function CustomHomeBuildersFAQ() {
  const faqs = [
    {
      question: 'How much does it cost to build a custom home in El Paso?',
      answer: 'Custom home costs in El Paso typically range from $150-$300+ per square foot depending on finishes, complexity, and location. A 2,500 sq ft home costs $375,000-$750,000+. Factors affecting price include lot preparation, architectural design, material quality, and custom features. Luxury homes with premium finishes can exceed $400 per square foot. Get detailed estimates from multiple builders to compare pricing and value.'
    },
    {
      question: 'How long does it take to build a custom home?',
      answer: 'Custom home construction in El Paso typically takes 8-14 months from groundbreaking to move-in. Timeline includes design and planning (2-4 months), permitting (1-2 months), and construction (6-10 months). Factors affecting timeline include home size, complexity, weather, material availability, and inspection schedules. Experienced builders provide realistic timelines with milestone dates and communicate about any delays promptly.'
    },
    {
      question: 'Do I need to own land before contacting a builder?',
      answer: 'Not necessarily. Many builders can help you find suitable lots or have relationships with land developers. However, owning land gives you more flexibility in builder selection and design. When evaluating lots, consider location, size, topography, utilities, soil conditions, and HOA restrictions. Builders can assess lot suitability and provide cost estimates for site preparation before you purchase.'
    },
    {
      question: 'What should I look for in a custom home builder?',
      answer: 'Key factors include local experience, licensing and insurance, portfolio of completed homes, client references, communication style, and financial stability. Visit their completed homes to assess quality. Review their contract terms, warranty coverage, and change order process. Choose a builder whose design aesthetic matches your vision and who demonstrates professionalism throughout the interview process.'
    },
    {
      question: 'How involved will I be in the building process?',
      answer: 'Your involvement level depends on the builder and your preferences. Most builders schedule regular meetings for material selections, design decisions, and progress updates. You\'ll make decisions about finishes, fixtures, colors, and upgrades. Quality builders welcome site visits but manage day-to-day construction. Clear communication expectations upfront ensures everyone understands roles and decision-making processes.'
    },
    {
      question: 'What energy-efficient features should I include?',
      answer: 'Essential features for El Paso include enhanced insulation (R-30+ walls, R-49+ attic), high-performance windows with low-E coatings, reflective roofing, efficient HVAC systems, LED lighting, and smart thermostats. Consider solar panels, proper home orientation, and strategic shading. Energy-efficient construction costs 5-10% more upfront but reduces utility bills by 30-50% annually. Many features qualify for rebates from El Paso Electric.'
    }
  ];

  return (
    <section className="py-20 px-6 bg-white">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-lg text-gray-600">
            Common questions about building custom homes in El Paso answered by local experts.
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <details key={index} className="group bg-gray-50 rounded-xl border border-gray-200 overflow-hidden">
              <summary className="flex items-center justify-between p-6 cursor-pointer hover:bg-gray-100 transition-colors">
                <h3 className="text-lg font-bold text-gray-900 pr-4">{faq.question}</h3>
                <i className="ri-arrow-down-s-line text-2xl text-gray-600 group-open:rotate-180 transition-transform flex-shrink-0"></i>
              </summary>
              <div className="px-6 pb-6">
                <p className="text-sm text-gray-700 leading-relaxed">{faq.answer}</p>
              </div>
            </details>
          ))}
        </div>

        <div className="mt-12 text-center bg-teal-50 rounded-xl p-8">
          <h3 className="text-2xl font-bold text-gray-900 mb-3">
            Still Have Questions?
          </h3>
          <p className="text-gray-700 mb-6">
            Connect with experienced custom home builders who can provide personalized answers for your dream home project.
          </p>
          <a href="#directory" className="inline-block px-8 py-3 bg-teal-600 text-white font-semibold rounded-lg hover:bg-teal-700 transition-colors whitespace-nowrap">
            Contact a Builder
          </a>
        </div>
      </div>
    </section>
  );
}
